// extracted by mini-css-extract-plugin
export default {"error":"Login__error___NkWxC"};